/* eslint-disable react-hooks/exhaustive-deps */
import useApi from "hooks/useApi";
import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  useMemo,
  useCallback,
} from "react";
import Constants from "utils/constants";

import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import Button from "components/buttonNew";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import * as S from "./styles";
import Select from "components/InputSelect/inputSelect.js";
import { GlobalContext } from "context/GlobalContext";
import RadioButton from "components/radioButton";
import { StoreStatusContext } from "context/StoreStatusContext";
import ContainerFlex from "components/ContainerFlex";

const CheckListItem = ({ item, onChange, value }) => {
  const { label, name } = item;
  const handleChangeCheck = (checked) => {
    onChange({ name, checked });
  };
  return (
    <div className="list-item">
      <span>{label}</span>
      <div className="radio-container">
        <div className="radio">
          <div>
            <RadioButton
              id={"sim"}
              name={name}
              checked={value}
              onClick={() => handleChangeCheck(true)}
            />
          </div>
          <label htmlFor="sim">Sim</label>
        </div>
        <div className="radio">
          <div>
            <RadioButton
              id={"nao"}
              name={name}
              checked={!value && value !== null}
              onClick={() => handleChangeCheck(false)}
            />
          </div>
          <label htmlFor="nao">Não</label>
        </div>
      </div>
    </div>
  );
};
const initialChecklistState = {
  tablet: null,
  computador: null,
  impressora: null,
  totem: null,
  telefone: null,
};
const items = [
  { label: "Tablet ok?", value: null, name: "tablet" },
  { label: "Computador ok?", value: null, name: "computador" },
  { label: "Impressora ok?", value: null, name: "impressora" },
  { label: "Totem ok?", value: null, name: "totem" },
  { label: "Telefone ok?", value: null, name: "telefone" },
];
const ModalCheckList = () => {
  const { user } = useContext(GlobalContext);
  const {
    stores,
    isLoading,
    setSelectedStore,
    checkStoreStatus,
    showChecklist,
    saveChecklist,
    showModal,
    storeStatus,
    selectedStore,
    setShowChecklist,
    isLoadingStores,
    setErrorModal,
    errorModal,
  } = useContext(StoreStatusContext);

  const [open, setOpen] = useState(false);
  useEffect(() => {
    setOpen(showModal);
  }, [showModal]);

  const [form, setForm] = useState(initialChecklistState);

  const disabledChekStatusButton = useMemo(() => {
    if (!selectedStore) return true;
  }, [selectedStore]);

  const disabledSubmitButton = useMemo(() => {
    if (!storeStatus) return true;
    if (!storeStatus.aberta && Object.values(form).some((e) => e === null))
      return true;
    return false;
  }, [storeStatus, form]);

  const [modalConfirmation, setModalConfirmation] = useState(false);

  const handleAction = useCallback(async () => {
    if (!storeStatus?.usuarioPertenceLoja) {
      setModalConfirmation(true);
      return;
    }
    const body = {
      ...form,
    };
    await saveChecklist(body);
  }, [form, storeStatus]);

  const onChangeSelectedStore = (e) => {
    setForm(initialChecklistState);
    setShowChecklist(false);

    const selectedId = e.target.value;
    const store = stores.find((s) => String(s.id) === String(selectedId));

    setSelectedStore(store);
  };
  const matchesQuery = useMediaQuery("(max-width: 768px)");

  const ConfirmationModal = () => (
    <Popup
      contentStyle={{ width: matchesQuery ? "80dvw" : "40dvw" }}
      modal
      nested
      lockScroll
      open={modalConfirmation}
      closeOnEscape={false}
      closeOnDocumentClick={false}
    >
      {(closeNested) => (
        <S.ModalContent>
          <div className="content">
            <div className="top-content">
              <p>ATENÇÃO</p>
            </div>

            <div style={{ textAlign: "center" }} className="checklist">
              <p style={{ color: "#e71037", fontSize: "2rem" }}>
                Você está fazendo login em uma loja diferente da loja do seu
                cadastro
              </p>
              <b style={{ fontSize: "1.7rem" }}>Deseja continuar?</b>
            </div>

            <hr />

            <ContainerFlex row end marginTop={8} gap={"8"}>
              <Button
                fitContent
                style={{ marginRight: 8 }}
                disabled={disabledSubmitButton}
                onClick={() => {
                  closeNested();
                  setModalConfirmation(false);
                }}
                outlined
              >
                Não
              </Button>
              <Button
                fitContent
                disabled={disabledSubmitButton}
                onClick={async () => {
                  await saveChecklist({ ...form });
                }}
              >
                Sim
              </Button>
            </ContainerFlex>
          </div>
        </S.ModalContent>
      )}
    </Popup>
  );
  const ErrorModal = () => (
    <Popup
      contentStyle={{ width: matchesQuery ? "70dvw" : "30dvw" }}
      modal
      nested
      lockScroll
      open={errorModal?.open}
      closeOnEscape={false}
      closeOnDocumentClick={false}
    >
      {(closeNested) => (
        <S.ModalContent>
          <div className="content">
            <div className="top-content">
              <p>Houve um erro ao registrar login</p>
            </div>

            <div className="checklist">
              <p>{errorModal?.message}</p>
            </div>

            <hr />

            <ContainerFlex row end marginTop={8} gap={"8"}>
              <Button
                style={{ marginRight: 8 }}
                disabled={disabledSubmitButton}
                onClick={() => {
                  closeNested();
                  setErrorModal({ open: false, message: "" });
                  setModalConfirmation(false);
                }}
                outlined
              >
                Fechar
              </Button>
            </ContainerFlex>
          </div>
        </S.ModalContent>
      )}
    </Popup>
  );
  return (
    <Popup
      contentStyle={{ width: matchesQuery ? "95dvw" : "50%" }}
      nested
      modal
      lockScroll
      open={open}
      closeOnEscape={false}
      closeOnDocumentClick={false}
    >
      {(close) => (
        <S.ModalContent>
          <ConfirmationModal />
          <ErrorModal />
          <div className="content">
            <div className="top-content">
              <p>CHECKLIST ABERTURA DE LOJA</p>
            </div>

            <div className="input-container"></div>
            <div className="checklist">
              <div className="list-item">
                <span>Operador</span>
                <span>{user?.nomeTitular}</span>
              </div>
              <div className="list-item">
                <span>Loja</span>

                {isLoadingStores ? null : (
                  <Select
                    label=""
                    id="motivo"
                    name={selectedStore?.name}
                    onChange={onChangeSelectedStore}
                    value={selectedStore.id ?? ""}
                    values={[
                      {
                        selected: true,
                        value: "",
                        label: "",
                        disabled: true,
                        hidden: true,
                      },
                      ...stores?.map((s) => ({ value: s.id, label: s.nome })),
                    ]}
                  ></Select>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: !storeStatus ? "flex-end" : "space-between",
                }}
              >
                {!!storeStatus ? (
                  storeStatus?.aberta ? (
                    <span
                      style={{
                        color: "#31c129",
                        fontSize: "1.5rem",
                        fontWeight: 600,
                      }}
                    >
                      Loja Aberta
                    </span>
                  ) : (
                    <span
                      style={{
                        color: "#e71037",
                        fontSize: "1.5rem",
                        fontWeight: 600,
                      }}
                    >
                      Loja Fechada
                    </span>
                  )
                ) : null}
                <Button
                  disabled={disabledChekStatusButton}
                  end
                  fitContent
                  onClick={checkStoreStatus}
                  loading={isLoading}
                >
                  Verificar status
                </Button>
              </div>
              {showChecklist &&
                items?.map((e) => {
                  return (
                    <CheckListItem
                      value={form[e.name]}
                      onChange={(e) =>
                        setForm((prev) => ({ ...prev, [e.name]: e.checked }))
                      }
                      item={e}
                    />
                  );
                })}
            </div>
          </div>

          <hr />

          <ContainerFlex row end marginTop={8}>
            <Button disabled={disabledSubmitButton} onClick={handleAction}>
              Gravar ação
            </Button>
          </ContainerFlex>
        </S.ModalContent>
      )}
    </Popup>
  );
};

export default ModalCheckList;
